<template>
    <div>
        <el-tabs v-model="pagePart" class="demo-tabs" @tab-click="handleClick">
            <el-tab-pane :label="i18n.tkey('lang_memberwork_whatsApp')" name="1"><span>{{i18n.tkey("lang_memberwork_whatsApp")}}</span></el-tab-pane>
            <el-tab-pane :label="i18n.tkey('lang_memberwork')" name="2"><span>{{i18n.tkey('lang_memberwork')}}</span></el-tab-pane>
            <el-tab-pane :label="i18n.tkey('lang_online_memberwork')" name="3"><span>{{i18n.tkey('lang_online_memberwork')}}</span></el-tab-pane>
        </el-tabs>

        <ul class="data-ul">
            <li>
                <qrcodeComponents :url="qrcodeUrl" />
            </li>

            <li>
                <span class="url-span">{{qrcodeUrl}}</span>
            </li>

            <li>
                <receiveCardShareBtnGroup :card="currCard" />
            </li>
        </ul>

    </div>
</template>

<script setup>
    import {getCurrentInstance, onMounted, ref, computed, inject, onBeforeMount} from 'vue'
    import receiveCardShareBtnGroup from "@/components/shopopee/share/receiveCardShareBtnGroup"
    import qrcodeComponents from "@/components/shopopee/common/qrcodeComponents"
    import myUtil from "@/util/util";

    const props = defineProps(["cardObj"])

    const i18n = inject("i18n")

    const currCard = ref(null)
    const qrcodeUrl = ref(null)
    const pagePart = ref("1")

    function fillCardInfo() {
        if (pagePart.value == "1"){
            qrcodeUrl.value = myUtil.generateCardWhatsappShareUrl(currCard.value.id)
        }else if (pagePart.value == "2"){
            qrcodeUrl.value = myUtil.generateCardShareUrl(currCard.value.id)
        }else{
            qrcodeUrl.value = myUtil.generateCardChatShareUrl(currCard.value.id)
        }
    }

    function handleClick(){
        fillCardInfo()
    }

    onBeforeMount(() => {
        if (null != props.cardObj){
            currCard.value = props.cardObj
            fillCardInfo()
        }
    })

</script>

<style scoped>
    .data-ul {
        list-style: none;
        padding-left: 0;
        text-align: center;
    }

    .url-span {
        font-size: 14px;
        color: #606266;
    }
</style>